import _ from 'lodash';
import {
  takeLatest, call, put,
} from 'redux-saga/effects';
import {
  deleteCardRequest, deleteCardResponse, getSavedCardsResponse, setSelectedCreditCard,
} from '../../slices/customer';
import axios from '../axiosConfig';

function* deleteCardWorker({
  payload: {
    card,
    customerId,
    withAddressOnly,
    doShowPaymentCheckboxes,
  },
}) {
  try {
    const url = '/users/deleteCard';
    const config = {
      method: 'POST',
      url,
      data: JSON.stringify({
        card: card.id,
        customerId,
        withAddressOnlyCards: withAddressOnly,
        doShowPaymentCheckboxes,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);
    yield put(setSelectedCreditCard({
      customerId,
      selectedCard: data && data.length ? _.find(data, (c) => c.isDefault && !c.isExpired)
              || _.find(data, (c) => !c.isExpired) : undefined,
    }));
    yield put(getSavedCardsResponse({ cards: data, customerId }));
    yield put(deleteCardResponse({ card }));
  } catch (ex) {
    console.log(ex);
    yield put(deleteCardResponse({ error: (ex || {}).detail || 'Could not delete card!', customerId, card }));
  }
}

function* deleteCardWatcher() {
  yield takeLatest(deleteCardRequest.toString(), deleteCardWorker);
}

export default deleteCardWatcher;
